<div class="container">
  <div class="form-container">
    <h3>Digital Millennium Copyright Act (DMCA) Policy</h3>
    <p class="gray-text">
      DML receives music submissions in various audio formats from independent artists, record labels,
      producers, managers, and other sources. Due to the high volume of daily uploads and submissions,
      we are unable to manually review all content. As such, we claim protection under the
      Digital Millennium Copyright Act (DMCA), Title 17, United States Code, Section 512.
      In accordance with the DMCA, all infringement notices must be submitted in writing and must include the
      required information as outlined by law. If you are a copyright owner and believe that your content has
      been used without authorization, please complete our DMCA Takedown Form and provide the all necessary
      details to fulfill your request.
    </p>

    <form [formGroup]="form">

      <div class="pb-12">

        <div class="user-dropdown-filter">
          <input type="text"
                 placeholder="I am *"
                 aria-label="I am"
                 matInput
                 #genresInput="matAutocompleteTrigger"
                 formControlName="userType"
                 [matAutocomplete]="typesEl">
          <mat-autocomplete #typesEl="matAutocomplete" [displayWith]="displayFn">
            @for (option of types; track option) {
              <mat-option [value]="option">{{option.displayName}}</mat-option>
            }
          </mat-autocomplete>
          <mat-icon class="open-trigger-icon" (click)="openPanel(genresInput)">arrow_drop_down</mat-icon>

        </div>

        @if (form.controls.userType.touched) {
          <div class="alert">

            @if (form.controls.userType.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }

          </div>
        }
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="fullLegalName" placeholder="Full Legal Name *">
        </div>

        @if (form.controls.fullLegalName.touched) {
          <div class="alert">

            @if (form.controls.fullLegalName.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="email" placeholder="Email *">
        </div>

        @if (form.controls.email.touched) {
          <div class="alert">

            @if (form.controls.email.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
            @if (form.controls.email.hasError('email')) {
              <div class="form-validation-error">
                Incorrect email
              </div>
            }
          </div>
        }
      </div>

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="organization" placeholder="Organization *">
        </div>

        @if (form.controls.organization.touched) {
          <div class="alert">

            @if (form.controls.organization.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="phone" placeholder="Phone *">
        </div>

        @if (form.controls.phone.touched) {
          <div class="alert">

            @if (form.controls.phone.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
            @if (form.controls.phone.hasError('pattern')) {
              <div class="form-validation-error">
                Invalid phone, available symbols are "-", "+", space,  numbers and parentheses, example +1(234) 567-89-00
              </div>
            }
          </div>
        }
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="address" placeholder="Address Line *">
        </div>

        @if (form.controls.address.touched) {
          <div class="alert">

            @if (form.controls.address.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="country" placeholder="Country *">
        </div>

        @if (form.controls.country.touched) {
          <div class="alert">

            @if (form.controls.country.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="city" placeholder="City *">
        </div>

        @if (form.controls.city.touched) {
          <div class="alert">

            @if (form.controls.city.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="state" placeholder="State">
        </div>
      </div>

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="zipCode" placeholder="Zip">
        </div>
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="infringingUrls" placeholder="Infringing urls *">
        </div>

        @if (form.controls.infringingUrls.touched) {
          <div class="alert">

            @if (form.controls.infringingUrls.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="additionalDetails" placeholder="Additional details">
        </div>
      </div>

      <div class="d-flex align-center">
        <mat-checkbox formControlName="agree1"></mat-checkbox>
        <div class="form-hint">
          I have read and accept the terms above.
        </div>
      </div>
      <div class="d-flex align-start">
        <mat-checkbox formControlName="agree2"></mat-checkbox>
        <div class="form-hint">
          I declare that I am the copyright owner or an authorized agent acting on behalf of the owner of the exclusive
          rights allegedly infringed. I have a good faith belief that the use of the material described in this notice
          is not authorized by the copyright owner, its agent, or the law. The information provided in this notification
          is accurate. I understand that each content field must pertain to a single alleged infringement;
          failure to do so may result in the notice not being processed.
        </div>
      </div>
      <div class="d-flex align-start">
        <mat-checkbox formControlName="agree3"></mat-checkbox>
        <div class="form-hint">
          I acknowledge that submitting false or bad faith claims of copyright infringement may result in legal consequences.
        </div>
      </div>
      <div class="d-flex align-start">
        <mat-checkbox formControlName="agree4"></mat-checkbox>
        <div class="form-hint">
          I understand that the affected user(s) will be notified of this takedown request, which may include disclosure of the contact information I have provided, upon their request.
        </div>
      </div>


      <button matButton="filled" class="button-regular w-100 pb-12" [disabled]="form.invalid" (click)="send()">Submit</button>

    </form>

  </div>

</div>



